module.exports = __webpack_public_path__ + "01-cube.5648a7e7264381b36f25.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/monashsvr/01-cube.svg
// module id = 313
// module chunks = 1